import { ApiUrl2,UserToken, ApiUrl } from '../../../helper/HelperAuth'
import { GlobalLoading } from '../../../store/constants'
import doFetch from '../../../infra/helper/fetchHelper'

export default (formbody) => async (dispatch) => {
    dispatch({ type: GlobalLoading, showLoading: true, latestProcessStatus: false });

    let formdata = new FormData();
    formdata.append("username",formbody.data["username"]);

    const url = ApiUrl2+'users-delete-account';
    const argument = {
        method: 'POST',             
        headers : {
            'Authorization': UserToken,
        },
        body: formdata
    };
    const response = await doFetch(url,argument);
    dispatch({ type: GlobalLoading, showLoading: false, latestProcessStatus : response.ok });
    
    return response;
    
};      